import Slider from './Slider';

$(() => {
	$('.theme-slider .keen-slider[data-slider-options]').each((i, elem) => {
		const options = JSON.parse(elem.getAttribute('data-slider-options'));
		elem._slider = new Slider(elem, options);
	});

	// opticache-rendered card lists (e.g. wp_opticache list_content.blade.php)
	// have no data-slider-options - they're plain .keen-slider markup with no
	// per-instance config, so init with generic defaults. perView is 'auto':
	// .card-travel's own min-width:350px (in _card.scss) governs how many
	// fit - a fixed numeric perView can't guarantee a 350px floor (e.g. 5-up
	// at 1400px works out to ~259px/card, well under it).
	const DESKTOP_BREAKPOINT = 992; // lg - PHP's $objects->chunk($multirow) always
	// pairs cards for the 2-row desktop look; below this width, unwrap each
	// pair back into separate single-card slides for a plain 1-row mobile list.
	// Checked once at init, not on resize - a live device rotation/resize
	// would need a re-check, add if that turns out to matter in practice.

	$('.list-slider-wrapper .keen-slider').each((i, elem) => {
		const $elem = $(elem);

		if (window.innerWidth < DESKTOP_BREAKPOINT) {
			$elem.find('.keen-slider__slide.flex-column').each((j, slide) => {
				const $slide = $(slide);
				$slide.children().each((k, card) => {
					$('<div class="keen-slider__slide"></div>').append(card).insertBefore($slide);
				});
				$slide.remove();
			});
		}

		// data-slider-options on the .keen-slider element sets desktop-only
		// (>=lg) arrows/loop/drag/counter - {"arrows": false, "loop": true,
		// "drag": false, "counter": false}. Below lg all four stay forced on
		// regardless (a list this narrow needs every navigation aid it can
		// get). Slider.js's updateArrows()/updateCount() read the
		// live-resolved instance.options on every optionsChanged (keen-slider
		// fires it when a breakpoint switches), so both react the same way
		// loop/drag natively do.
		//
		// keen-slider only lets ONE breakpoint entry win at a given width -
		// the LAST one, in object-key order, whose media query still
		// matches. It does NOT cascade multiple matches, so every breakpoint
		// from lg up has to redeclare its own `slides` value alongside
		// arrows/loop/drag/counter, and the object's keys must stay in
		// strictly ascending min-width order - inserting a later key that
		// also matches wider breakpoints (e.g. appending a 992px entry after
		// 1400px) makes it win at every width above it too, silently
		// dropping the wider breakpoints' slides.perView.
		const desktopOptions = JSON.parse(elem.getAttribute('data-slider-options') || '{}');
		const desktop = {
			arrows: desktopOptions.arrows ?? true,
			loop: desktopOptions.loop ?? false,
			drag: desktopOptions.drag ?? true,
			counter: desktopOptions.counter ?? true,
		};

		elem._slider = new Slider(elem, {
			loop: true,
			arrows: true,
			drag: true,
			slides: {
				perView: 1.15,
				spacing: 16
			},
			breakpoints: {
				'(min-width: 576px)': { slides: { perView: 2.15, spacing: 16 } },
				// md and lg both showed 3 - one entry covers 768-1199 instead of
				// two identical breakpoints (mobile-first cascade carries it up).
				'(min-width: 768px)': { slides: { perView: 3, spacing: 16 } },
				'(min-width: 992px)': $.extend({ slides: { perView: 3, spacing: 16 } }, desktop),
				'(min-width: 1200px)': $.extend({ slides: { perView: 4, spacing: 16 } }, desktop),
				'(min-width: 1400px)': $.extend({ slides: { perView: 5, spacing: 16 } }, desktop)
			}
		});
	});

	// Any other keen-slider that ships its own complete data-slider-options
	// (e.g. #activities .activities-body in details_camps/activities.blade.php -
	// a slider below lg, disabled back to plain stacked flow from lg up via
	// its own breakpoints.disabled:true). Excludes .theme-slider/
	// .list-slider-wrapper above so an element already handled by one of
	// them doesn't get instantiated a second time here.
	$('.keen-slider[data-slider-options]').not('.theme-slider .keen-slider, .list-slider-wrapper .keen-slider').each((i, elem) => {
		elem._slider = new Slider(elem, JSON.parse(elem.getAttribute('data-slider-options')));
	});
});
